import BaseApi from '../BaseApi';

class UserTreatmentApi extends BaseApi {
  changeHandler(id: number, type: 'cs' | 'doctor') {
    return this.put(`/${id}/change-handler`, { type });
  }

  revertCancelRequest(id: number) {
    return this.post(`/${id}/revert-cancel-request`, {});
  }

  protected getSpecificApiPrefix(): string {
    return 'v2/managers/user-treatments';
  }
}

export default UserTreatmentApi;
